import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useShipmentDetailModel } from "./shipmentDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, message } from "antd";
import { useDictModel } from "@/views/base/dict/dictModel";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { IShipmentTabEnum } from "../../shimentTypes";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useDtpDetailModel } from "@/views/document/agreement/view/details/dtpDetailModel";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal, tabActive, setTabActive, insertOrUpdateLog, insertOrUpdateShipment, getShipmentDetailOne, resetPageCache, transferInvoices } = useShipmentDetailModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { updateFormVal } = useDtpDetailModel(() => []);
    useEffect(() => {
        if (!editFormVal.id) {
            getShipmentDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("5-2") && resetPageCache("edit")
            setTabActive(IShipmentTabEnum.BASE_DETAIL);
        }
    }, [selectedNavId])

    //表单提交
    const onSubmit = () => {
        //在物流进程页面保存 提交物流进程接口
        if (tabActive === IShipmentTabEnum.LOGISTICS_PROCESS) {
            insertOrUpdateLog();
            return;
        }
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdateShipment({
                ...val,
                transportName: getTreeNodeName(val.transportCode)
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    const orderStatu: IDescription[] = [
        {
            label: "外贸合同号",
            value: editFormVal.saleRealCode,
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(editFormVal.status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
    ]

    const action = <>
        {mode === "edit" &&
            <YhAuth resCode={ResourceAuthEnum.SH_ED_TURNY}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={async () => {
                        transferInvoices().then(res => {
                            if (res) {
                                updateFormVal("edit", null)
                                replaceNav("5-2", "9-1-2", { id: res as string, mode: "edit" });
                            }
                        })
                    }}
                >转运输单据</Button>
            </YhAuth>}

        <YhAuth resCode={ResourceAuthEnum.SH_ED_SAVE} isShow={mode === "add"}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "5")}
        >返回</Button>
    </>

    return (
        <YhBox title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}